module.exports = __webpack_public_path__ + "img/alert-circle.61ed8db7.svg";